<script setup lang="ts">
import { MagazineProps } from "./Magazine.props"
import { customPaths } from "~/utils/constants"

defineProps<MagazineProps>()
</script>

<template>
  <div class="magazine-wrapper padded">
    <BannerWikiMagazine
      v-if="heroSection"
      v-bind="heroSection"
      class="negative-margined"
    />

    <ClientOnly>
      <SearchMagazineSearchBar />
      <template #fallback>
        <SkeletonMagazineSearchBar />
      </template>
    </ClientOnly>

    <div class="flex flex-col items-center py-6 md:gap-6">
      <p class="hyppo-bold md:elephant-bold mb-2 text-center">
        {{ $t("magazine.lastArticle") }}
      </p>

      <div
        class="flex w-full flex-col justify-center gap-6 md:flex-row"
        v-if="cards"
      >
        <CardBlogPost
          class="w-full md:w-1/3"
          v-for="(card, index) in cards.slice(0, 3)"
          :key="index"
          v-bind="card"
        />
      </div>

      <UtilsButton
        :text="$t('magazine.discoverAll')"
        :path="customPaths.magazineAllPosts"
        theme="outlined-green"
        class="mt-10 w-max md:m-0"
      />
    </div>

    <CartUtilsLogin
      :upperText="$t('loginBanner.type2.upperText')"
      show-login-button
      class="negative-margined text-center"
    />

    <div class="negative-margined bg-grey-main py-6">
      <div class="padded">
        <p class="hyppo-bold">
          {{ $t("magazine.category") }}
        </p>

        <p class="beaver my-4 md:mt-2">
          {{ $t("magazine.chooseCategory") }}
        </p>

        <div class="grid-container-categories">
          <CardMagazineCategory
            v-for="category in categories"
            :key="category.title"
            v-bind="category"
          />
        </div>
      </div>
    </div>

    <BannerNewsletter class="negative-margined md:padded" />
  </div>
</template>
